
    import './styles.scoped.css';
    export default {
  "tabs-header": "awsui_tabs-header_14rmt_ap8kh_198",
  "tabs-header-list": "awsui_tabs-header-list_14rmt_ap8kh_206",
  "pagination-button": "awsui_pagination-button_14rmt_ap8kh_223",
  "pagination-button-left": "awsui_pagination-button-left_14rmt_ap8kh_230",
  "pagination-button-left-scrollable": "awsui_pagination-button-left-scrollable_14rmt_ap8kh_233",
  "pagination-button-right": "awsui_pagination-button-right_14rmt_ap8kh_237",
  "pagination-button-right-scrollable": "awsui_pagination-button-right-scrollable_14rmt_ap8kh_240",
  "tabs-tab": "awsui_tabs-tab_14rmt_ap8kh_245",
  "tabs-tab-label": "awsui_tabs-tab-label_14rmt_ap8kh_257",
  "tabs-tab-link": "awsui_tabs-tab-link_14rmt_ap8kh_273",
  "refresh": "awsui_refresh_14rmt_ap8kh_292",
  "tabs-tab-disabled": "awsui_tabs-tab-disabled_14rmt_ap8kh_343",
  "tabs-tab-active": "awsui_tabs-tab-active_14rmt_ap8kh_378",
  "tabs-header-with-divider": "awsui_tabs-header-with-divider_14rmt_ap8kh_385",
  "root": "awsui_root_14rmt_ap8kh_389",
  "tabs": "awsui_tabs_14rmt_ap8kh_198",
  "tabs-content": "awsui_tabs-content_14rmt_ap8kh_430",
  "tabs-content-active": "awsui_tabs-content-active_14rmt_ap8kh_434",
  "tabs-content-wrapper": "awsui_tabs-content-wrapper_14rmt_ap8kh_447",
  "with-paddings": "awsui_with-paddings_14rmt_ap8kh_447",
  "tabs-container-content-wrapper": "awsui_tabs-container-content-wrapper_14rmt_ap8kh_452"
};
  